import React from 'react';
import { Clock, TrendingUp, BrainCircuit } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-16 md:py-24 px-4 bg-cream" data-id="element-543" data-mp="2sjcao8k4pyk8">
      <div className="max-w-4xl mx-auto" data-id="element-544" data-mp="2sgq1y5li5d0f">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-forest mb-12 text-center" data-id="element-545" data-mp="36azhh2bp6ph9">
          ⏰ Por Qué Decidir Ahora
        </h2>

        <div className="space-y-8" data-id="element-546" data-mp="31h4p7ai1126k">
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-urgency flex flex-col md:flex-row gap-6 items-start" data-id="element-547" data-mp="3g7lzljcn32fl">
            <div className="bg-urgency/10 p-4 rounded-full shrink-0" data-id="element-548" data-mp="3b8is7s96sk4g">
              <TrendingUp className="text-urgency" size={32} data-id="element-549" data-mp="3p93b0of3qfxy" />
            </div>
            <div data-id="element-550" data-mp="3l7hw6xj0brl4">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-551" data-mp="3l6yjbv87rtdy">
                Razón #1: El Precio Sube
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-552" data-mp="1uvask5evvgdt">
                Este es el precio de lanzamiento. Una vez que se superen las
                primeras unidades vendidas, el precio vuelve a $32.90 USD. No
                es un truco de marketing. Es la política de lanzamiento real.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-forest flex flex-col md:flex-row gap-6 items-start" data-id="element-553" data-mp="32ru75yutlndi">
            <div className="bg-forest/10 p-4 rounded-full shrink-0" data-id="element-554" data-mp="37jlzoexje36a">
              <Clock className="text-forest" size={32} data-id="element-555" data-mp="3ci6s3s6jrik6" />
            </div>
            <div data-id="element-556" data-mp="3cjzyr7h5u2s6">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-557" data-mp="3giz42t6t01k5">
                Razón #2: Cada Noche Que Pasa Es Una Noche Perdida
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-558" data-mp="3liv64mvxxix2">
                La inflamación crónica no toma días libres. Cada noche que cenas
                de la misma manera, acumulas un ciclo inflamatorio más. El mejor
                momento para empezar fue hace un año. El segundo mejor momento
                es esta noche.
              </p>
            </div>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border-l-4 border-gold flex flex-col md:flex-row gap-6 items-start" data-id="element-559" data-mp="1o3r6kjmhugic">
            <div className="bg-gold/20 p-4 rounded-full shrink-0" data-id="element-560" data-mp="1k374d1n2cmpc">
              <BrainCircuit className="text-gold-dark" size={32} data-id="element-561" data-mp="1y1oqiuxblr55" />
            </div>
            <div data-id="element-562" data-mp="1t0r9ilo1r358">
              <h3 className="text-xl font-bold text-dark mb-3" data-id="element-563" data-mp="1t07rz62b6grq">
                Razón #3: Tu Cuerpo Tiene Memoria
              </h3>
              <p className="text-dark/80 leading-relaxed" data-id="element-564" data-mp="26z7gmdptmvnw">
                Cuanto más tiempo permanece el sistema inflamatorio activado,
                más tiempo tarda en regularse. Empezar hoy significa resultados
                esta semana. Esperar un mes significa empezar desde más atrás.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}